import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M30.59 14.69a2.02 2.02 0 0 0-1.07-1.48c-.28-.14-.6-.22-.91-.22H27v-2c0-.53-.21-1.04-.59-1.41s-.88-.59-1.41-.59h-8.66l-3.48-2.6c-.35-.26-.76-.4-1.2-.4H5c-.53 0-1.04.21-1.41.59S3 7.46 3 7.99v18.05a.84.84 0 0 0 .08.37c.03.06.06.12.1.18.02.03.05.06.08.09.01.02.03.03.04.05.08.08.17.14.27.19.02 0 .04.01.06.02.11.04.23.07.35.07H26c.43 0 .81-.28.95-.68l3.56-10.69c.1-.3.13-.62.08-.94zM11.66 8l3.48 2.6c.35.26.76.4 1.2.4H25v2H8.73c-.42 0-.83.13-1.17.38s-.59.59-.73.99L5 19.84V8zm13.62 17H5.39l3.34-10h19.89l-3.33 10z"
    />
  </svg>
);
const SvgIconFolderOpen = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFolderOpen);
export default Memo;
